"use client"

import React, { ReactNode } from "react"
import { ThemeProvider } from "styled-components"
import { baseTheme } from "ui/theme"

export function StyledComponentsProvider({ children }: { children?: ReactNode }) {
  return <ThemeProvider theme={baseTheme}>{children}</ThemeProvider>
}
